import { Component, OnInit, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

export interface PeriodicElement {
  name: string;
  Unternehmensgrosse: string;
}

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['prices', 'global', 'register', 'settings', 'model_realEstate'],
    },
  ],
})
export class RegistrationComponent implements OnInit {
  private metaTagService = inject(Meta);

  ngOnInit() {
    this.initializeData();
  }

  initializeData() {
    this.invokeMetaTags();
  }

  invokeMetaTags() {
    this.metaTagService.addTags([
      {
        name: 'description',
        content:
          'Jetzt 7 Tage gratis testen. Das Schweizer Tool zur Kostenberechnung für Architekten, Bauherren und Projektentwickler. Einfach, praktisch und transparent.',
      },
      { name: 'Keywords', content: 'Mix' },
      // OpenGraph
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'kennwerte' },
      {
        property: 'og:description',
        content:
          'Jetzt 7 Tage gratis testen. Das Schweizer Tool zur Kostenberechnung für Architekten, Bauherren und Projektentwickler. Einfach, praktisch und transparent.',
      },
      // Twitter
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@kennwerte' },
      { name: 'twitter:title', content: 'kennwerte' },
      {
        name: 'twitter:description',
        content:
          'Jetzt 7 Tage gratis testen. Das Schweizer Tool zur Kostenberechnung für Architekten, Bauherren und Projektentwickler. Einfach, praktisch und transparent.',
      },
    ]);
  }
}
